import { render } from "./p3Page.vue?vue&type=template&id=21a97aae&scoped=true"
import script from "./p3Page.vue?vue&type=script&lang=js"
export * from "./p3Page.vue?vue&type=script&lang=js"

import "./p3Page.vue?vue&type=style&index=0&id=21a97aae&scoped=true&lang=css"

import exportComponent from "/Users/song/Desktop/pro/homePage/沙漠传说/desertlegendhomepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a97aae"]])

export default __exports__